import React from 'react';
import { ConfigurationSection } from "@features/settings/pages/StyleComponents";
import { BodyLarge, BodyRegular } from "../../atoms/fonts/Body";
import Colours from "../../atoms/Colours";
import { buildNumber } from '@shared/services/EnvironmentVariables';

export function BuildVersion() {
  return (
    <ConfigurationSection>
      <BodyLarge colour={Colours.blue}>Version details</BodyLarge>
      <BodyRegular>Build: {buildNumber}</BodyRegular>

    </ConfigurationSection>
  )
}
